const DATA_MOCKUP = [
  {
    title: "ขอบคุณ “คุณปัท” ที่เข้ามารับริการกับคุณหมอแนนที่เฌอบัวคลินิกเวชกรรมค่ะ",
    excerpt: "ค้นพบขั้นตอนและส่วนผสมสำคัญเพื่อรักษาผิวให้ดูอ่อนเยาว์และมีสุขภาพดีในทุกช่วงอายุ",
    date: "15 ม.ค. 2025",
    readTime: "อ่าน 5 นาที",
    category: "เคล็ดลับการดูแลผิว",
    author: "พญ.ธัชตะวัน แดงอุบล",
    image: "/S__12787716.jpg"
  },
  {
    title: "ขอบคุณ “คุณเมย์” ที่ไว้ใจเฌอบัวคลินิกเวชกรรมได้ดูแลค่ะ",
    excerpt: "สิ่งที่คุณควรรู้ก่อนครั้งแรกเพื่อให้ได้ผลลัพธ์ที่ดีที่สุด",
    date: "8 ม.ค. 2025",
    readTime: "อ่าน 4 นาที",
    category: "การดูแลผู้ป่วย",
    author: "ทีม CherBour",
    image: "/S__12787717.jpg"
  },
  {
    title: "ขอบคุณ “คุณเปา” ที่ไว้ใจให้คุณหมอแนนได้ดูแลค่ะ",
    excerpt: "เคล็ดลับสำคัญเพื่อรักษาผิวให้ชุ่มชื้นและมีสุขภาพดีในช่วงที่อากาศเย็น",
    date: "3 ม.ค. 2025",
    readTime: "อ่าน 6 นาที",
    category: "เคล็ดลับการดูแลผิว",
    author: "พญ.ธัชตะวัน แดงอุบล",
    image: "/S__12787718.jpg"
  },
];

export default DATA_MOCKUP;